/**
 * Fetches a path once and stores the result.
 */
const cache = {}
export async function requestThenCache<T = any>(path: string): Promise<T> {
  if (cache[path]) {
    return cache[path]
  }

  cache[path] = await (async () => {
    return requestText(path)
  })()

  return cache[path]
}

function handleError(response) {
  if (!response.ok) {
    throw Error(`Feil ved lasting: ${response.status}: ${response.statusText}`)
  }
  return response
}

const TIMEOUT = {
  response: 5000, // Wait 5 seconds for the server to start sending,
  deadline: 10000 // but allow 1 minute for the file to finish loading.
}

export async function requestText(url: string): Promise<any> {
  if (__IS_SERVER__) {
    const supareagent = require('superagent')
    const { name, version } = require('../../package.json')

    return supareagent
      .get(url)
      .set('User-Agent', `${name}/${version} (node/superagent)`)
      .timeout(TIMEOUT)
      .then(handleError)
      .then(res => res.body)
  }

  return fetch(url)
    .then(handleError)
    .then(res => res.text())
}

export async function request(url: string): Promise<any> {
  if (__IS_SERVER__) {
    const supareagent = require('superagent')
    const { name, version } = require('../../package.json')

    return supareagent
      .get(url)
      .timeout(TIMEOUT)
      .set('User-Agent', `${name}/${version} (node/superagent)`)
      .set('Accept', 'application/json')
      .then(handleError)
      .then(res => res.body)
  }

  return fetch(url)
    .then(handleError)
    .then(res => res.json())
}
